import { html } from 'lit';
import { Purpose } from '@common/types/model.js';
import type { TefComs4cs4p } from '@src/components/TefComs4cs4p.js';

//
// renders a single USER BOUND purpose block
//
export const singlePurposeUserBound = function render(this: TefComs4cs4p, purpose : Purpose)
  : ReturnType<typeof html> {
  return html`
    <section class="section section--prio-bg-2 section--size-flat u-block-centered">
      <div class="typography-display--6 u-sb--flat" align="center">Vertragsinhaber</div>
    </section>

    <div class="container">
      ${purpose.apps!.map((app) => this.getTemplateFn('singleAppConsent')(app))}
    </div>`;
};
